import PropTypes from 'prop-types'
import React from 'react'
import * as Yup from 'yup'

import {
  Form,
  FormikDialog,
  FormikRating,
  FormikTextField,
  FIELD_REQUIRED,
  SupplierField,
} from 'src/modules/ui'

import { useSuppliers } from '../hooks'

const LeaveReviewModal = ({ supplier, ...props }) => {
  const { leaveReview } = useSuppliers()

  const handleSubmit = async ({ rating, text }) =>
    leaveReview({
      supplierId: supplier.id,
      rating,
      text,
    })

  const initialValues = {
    text: '',
    rating: '',
  }

  const validationSchema = Yup.object().shape({
    text: Yup.string().required(FIELD_REQUIRED),
    rating: Yup.string().required(FIELD_REQUIRED),
  })

  return (
    <FormikDialog
      initialValues={initialValues}
      onSubmit={handleSubmit}
      submitText="Leave Recommendation"
      successNotification="Recommendation left"
      title="Leave Recommendation"
      validationSchema={validationSchema}
      {...props}
    >
      <Form>
        <SupplierField label="For" supplier={supplier} />
        <FormikTextField
          autoFocus
          fullWidth
          label="Recommendation"
          name="text"
          margin="normal"
          multiline
          minRows={10}
          type="text"
        />
        <FormikRating fullWidth label="Rating" name="rating" margin="normal" />
      </Form>
    </FormikDialog>
  )
}

LeaveReviewModal.propTypes = {
  supplier: PropTypes.shape({
    id: PropTypes.number,
    logo: PropTypes.string,
    name: PropTypes.string,
  }),
  trigger: PropTypes.func,
}

export default LeaveReviewModal
